import { PlaygroundSubsection, StudioSection } from '../types/store';

export function getBiView(isStashVisitorView: boolean) {
  if (isStashVisitorView) {
    return 'stash';
  }

  return 'submit';
}

export function getBiComponent(
  activeSection: StudioSection,
  activePlaygroundSubsection: PlaygroundSubsection,
  isStashVisitorView: boolean,
  contentType?: string
) {
  if (isStashVisitorView) {
    return 'stash_visitor';
  }

  switch (activeSection) {
    case StudioSection.DRAFTS:
      return 'studio_drafts';
    case StudioSection.PUBLISHED:
      return contentType === 'posts'
        ? 'studio_published_posts'
        : 'studio_published';
    case StudioSection.PUBLISHED_GALLERIES:
      return 'studio_published_galleries';
    case StudioSection.PUBLISHED_TIERS:
      return 'studio_published_tiers';
    case StudioSection.SCHEDULED:
      return 'studio_scheduled';
    case StudioSection.LITERATURE:
      return 'studio_drafts_literature';
    case StudioSection.JOURNALS:
      return 'studio_drafts_journals';
    case StudioSection.PLAYGROUND:
      if (activePlaygroundSubsection === PlaygroundSubsection.Draw) {
        return 'studio_playground_draw';
      }
      return `studio_playground_${activePlaygroundSubsection}`;
    case StudioSection.STASH:
      return 'studio_stash';
    case StudioSection.BOOKMARKS:
      return 'studio_shortcuts';
    case StudioSection.SHOP_REPORTS:
      return 'studio_analytics';
    case StudioSection.PRODUCTS_LOBBY:
      return 'studio_products_lobby';
    case StudioSection.PRODUCTS_TIER:
      return 'studio_products_tier';
    case StudioSection.PRODUCTS_TIER_UNLISTED:
      return 'studio_products_tier_unlisted';
    case StudioSection.PRODUCTS_COMMISSION:
      return 'studio_products_commission';
    case StudioSection.PRODUCTS_ORIGINAL:
      return 'studio_products_original';
    case StudioSection.PRODUCTS_ORIGINAL_UNLISTED:
      return 'studio_products_original_unlisted';
    case StudioSection.PRODUCTS_PREMIUM_GALLERY:
      return 'studio_products_premium_gallery';
    case StudioSection.PRODUCTS_PCP:
      return 'studio_products_pcp';
    case StudioSection.PRODUCTS_PCP_UNLISTED:
      return 'studio_products_pcp_unlisted';
    case StudioSection.PRODUCTS_EXCLUSIVE:
      return 'studio_products_exclusive';
    case StudioSection.PRODUCTS_EXCLUSIVE_UNLISTED:
      return 'studio_products_exclusive_unlisted';
    case StudioSection.SELLER_DISCOUNTS_ACTIVE:
      return 'studio_discounts_active';
    case StudioSection.SELLER_DISCOUNTS_SCHEDULED:
      return 'studio_discounts_scheduled';
    case StudioSection.SELLER_DISCOUNTS_ENDED:
      return 'studio_discounts_ended';
    case StudioSection.SELLER_DISCOUNTS_ALL:
      return 'studio_discounts_all';
    case StudioSection.APPS:
      return 'studio_applications_published';
    case StudioSection.APPS_UNLISTED:
      return 'studio_applications_unpublished';
    case StudioSection.EARNINGS:
      return 'studio_earnings';
    case StudioSection.ORDERS_STATUS:
    case StudioSection.ORDERS_ORIGINALS:
      return 'studio_orders';
    case StudioSection.HOME:
      return 'studio_home';

    default:
      return 'studio';
  }
}
